module.exports = __webpack_public_path__ + "images/feature/group-2-96f225a96ca268f45257fa76b6014bf2.gif";